import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CardContent, CardHeader, Grid } from '@material-ui/core';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import ProgressFullScreen from '../../../../components/Compartilhados/ProgressFullScreen';
import InputMask from 'react-input-mask';
import { ServiceValues } from '../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../services/ServiceEW';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
const timeout = ServiceValues.timeout;

function DialogEditEndereco(props) {
  const {
    className,
    history,
    user,
    usuario,
    setEmpresa,
    showMessageSnack,
    setShowMessageSnack,
    messageSnack,
    setMessageSnack,
    typeSnack,
    setTypeSnack,
    open,
    setOpen,
    index_endereco,
    setIndex_endereco,
    ...rest } = props;
  const [loading, setLoading] = useState(false);
  const [cepEmpresa, setCepEmpresa] = useState('');
  const [rua, setRua] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [codigoIbge, setcodigoIbge] = useState('');
  const [apelido_endereco, setApelido_endereco] = useState('');
  const [maskCep, setMaskCep] = useState('99.999-999');
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));


  useEffect(() => {
    async function carregarEndereco() {
      if(index_endereco >= 0 && index_endereco < usuario.enderecos.length){
        setCepEmpresa(usuario.enderecos[index_endereco].cep);
        setRua(usuario.enderecos[index_endereco].logradouro);
        setApelido_endereco(usuario.enderecos[index_endereco].apelido);
        setNumero(usuario.enderecos[index_endereco].numero);
        setComplemento(usuario.enderecos[index_endereco].complemento);
        setBairro(usuario.enderecos[index_endereco].bairro);
        setCidade(usuario.enderecos[index_endereco].cidade);
        setEstado(usuario.enderecos[index_endereco].uf);
        setcodigoIbge(usuario.enderecos[index_endereco].codigoIbge);
      }
      else{

      }
    }
    carregarEndereco();
  }, [index_endereco]);

  async function consultarCep(value) {
    try{
      setLoading(true);
      // const informacoesEndereco = await cep(value);
      const api = ServiceAxios('https://viacep.com.br/ws/', timeout);
      const informacoesEndereco = await api.get('/' + value + '/json/');
      console.log(informacoesEndereco);
      setBairro(informacoesEndereco.data.bairro);
      setCidade(informacoesEndereco.data.localidade);
      setRua(informacoesEndereco.data.logradouro);
      setEstado(informacoesEndereco.data.uf);
      setcodigoIbge(informacoesEndereco.data.ibge);
      setLoading(false);
    }
    catch (e) {
      setLoading(false);
      setMessageSnack('Erro ao obter informações para o CEP informado.');
      setTypeSnack('error');
      setShowMessageSnack('success');
    }
  }

  function saveEndereco() {
    const novoEndereco = {
      logradouro: rua,
      numero: numero,
      bairro: bairro,
      complemento: complemento,
      cep: cepEmpresa,
      uf: estado,
      cidade: cidade,
      codigoIbge: codigoIbge,
      apelido: apelido_endereco,
      pais: 'Brasil'
    };
    if (usuario.enderecos[index_endereco].idEndereco){
      novoEndereco.idEndereco = usuario.enderecos[index_endereco].idEndereco;
    }
    usuario.enderecos[index_endereco] = novoEndereco;
    setEmpresa(usuario);
    setRua('');
    setCepEmpresa('');
    setNumero('');
    setComplemento('');
    setBairro('');
    setCidade('');
    setEstado('');
    setApelido_endereco('');
    setcodigoIbge('');
    setIndex_endereco(-1);
    setOpen(false);

  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>

      {index_endereco >= 0 && index_endereco < usuario.enderecos.length ?
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          maxWidth={'md'}
          fullWidth
        >
          <DialogContent>
            <ValidatorForm
              autoComplete="off"
              onSubmit={saveEndereco}
            >
              <CardHeader
                subheader="Edite as informações do seu endereço"
                title={usuario.enderecos[index_endereco].apelido}
              />
              <CardContent>
                <ProgressFullScreen
                  open={loading}
                  setOpen={setLoading}
                />
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    item
                    md={2}
                    xs={12}
                  >
                    <TextValidator
                      fullWidth
                      label="Apelido"
                      helperText="Insira um apelido para seu endereço."
                      onChange={e => setApelido_endereco(e.target.value)}
                      value={apelido_endereco}
                      margin="dense"
                      name="apelido_endereco"
                      variant="outlined"
                      validators={['required']}
                      errorMessages={['Informe um apelido para seu endereço.!']}
                    />
                  </Grid>
                  <Grid
                    item
                    md={2}
                    xs={12}
                  >
                    <InputMask
                      mask={maskCep}
                      value={cepEmpresa}
                      onChange={e => setCepEmpresa(e.target.value.replace('.', '').replace('-', ''))}
                      onBlur={e => consultarCep(e.target.value.replace('.', '').replace('-', ''))}
                    >
                      {
                        (inputProps) =>
                          <TextValidator
                            fullWidth
                            label="CEP"
                            helperText="Insira o CEP."
                            margin="dense"
                            name="cep"
                            onChange={inputProps.onChange}
                            onBlur={inputProps.onBlur}
                            variant="outlined"
                            validators={['required']}
                            errorMessages={['Informe o CEP!']}
                          />
                      }
                    </InputMask>
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={12}
                  >
                    <TextValidator
                      fullWidth
                      label="Rua"
                      helperText="Insira a rua."
                      margin="dense"
                      name="rua"
                      onChange={e => setRua(e.target.value)}
                      value={rua}
                      variant="outlined"
                      validators={['required']}
                      errorMessages={['Informe a rua!']}
                    />
                  </Grid>
                  <Grid
                    item
                    md={2}
                    xs={12}
                  >
                    <TextValidator
                      fullWidth
                      label="Número"
                      helperText="Número."
                      onChange={e => setNumero(e.target.value)}
                      value={numero}
                      margin="dense"
                      name="numero"
                      variant="outlined"
                      validators={['required']}
                      errorMessages={['Informe o número!']}
                    />
                  </Grid>
                  <Grid
                    item
                    md={2}
                    xs={12}
                  >
                    <TextValidator
                      fullWidth
                      label="Complemento"
                      helperText="Insira um complemento."
                      margin="dense"
                      name="complemento"
                      variant="outlined"
                      onChange={e => setComplemento(e.target.value)}
                      value={complemento}
                      validators={['maxStringLength:70']}
                      errorMessages={['Complemeto muito longo!']}
                    />
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={12}
                  >
                    <TextValidator
                      fullWidth
                      label="Bairro"
                      helperText="Insira o bairro."
                      margin="dense"
                      name="bairro"
                      variant="outlined"
                      onChange={e => setBairro(e.target.value)}
                      value={bairro}
                      validators={['required']}
                      errorMessages={['Informe o bairro!']}
                    />
                  </Grid>
                  <Grid
                    item
                    md={2}
                    xs={12}
                  >
                    <TextValidator
                      fullWidth
                      label="Cidade"
                      onChange={e => setCidade(e.target.value)}
                      value={cidade}
                      helperText="Insira a cidade."
                      margin="dense"
                      name="cidade"
                      variant="outlined"
                      validators={['required']}
                      errorMessages={['Informe a cidade!']}
                    />
                  </Grid>
                  <Grid
                    item
                    md={2}
                    xs={12}
                  >
                    <TextValidator
                      fullWidth
                      label="Estado"
                      helperText="Estado."
                      margin="dense"
                      name="estado"
                      onChange={e => setEstado(e.target.value)}
                      value={estado}
                      variant="outlined"
                      validators={['required']}
                      errorMessages={['Informe o estado!']}
                    />
                  </Grid>
                  <Grid
                    item
                    md={2}
                    xs={12}
                  >
                    <TextValidator
                      fullWidth
                      label="Código IBGE"
                      helperText="Código IBGE do seu endereço."
                      margin="dense"
                      name="codigoIbge"
                      disabled
                      value={codigoIbge}
                      variant="outlined"
                      validators={['required']}
                      errorMessages={['Informe o estado!']}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <DialogActions>
                <Button
                  color="primary"
                  type="submit"
                  variant="contained"
                >
                  Salvar
                </Button>
              </DialogActions>
            </ValidatorForm>
          </DialogContent>

        </Dialog>
        :
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"ERRO"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Não foi possível carregar as informações para esse endereço
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" autoFocus>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      }

    </div>

  );
}

DialogEditEndereco.propTypes = {
  className: PropTypes.string,
  usuario: PropTypes.object.isRequired,
};

export default DialogEditEndereco;


